import { useState } from "react";
import { Main } from "layouts";
import { Button } from "expano-components";

import WarehousesList from "./components/WarehousesList";
import WarehouseRackSchemas from "./components/WarehouseRackSchemas";

import { ReactComponent as WarehouseIcon } from "icons/warehouse.svg";

const Warehouses = () => {
  const [is_open_create_modal, setOpenCreateModal] = useState(false);

  return (
    <Main
      page={{
        name: "Zarządzanie magazynem",
        icon: <WarehouseIcon />,
        breadcrumbs: [{ name: "Zarządzanie magazynem" }],
        buttons: (
          <Button
            type="add"
            text="Dodaj magazyn"
            onClick={() => setOpenCreateModal(true)}
          />
        ),
      }}
    >
      <div className="row">
        <WarehousesList
          is_open_create_modal={is_open_create_modal}
          setOpenCreateModal={setOpenCreateModal}
        />
        <WarehouseRackSchemas />
      </div>
    </Main>
  );
};

export default Warehouses;
